export default "__VITE_ASSET__l28SqYmb__"